var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalThematicsSelection = (function(superClass) {
  utils.extend(ModalThematicsSelection, superClass);

  function ModalThematicsSelection() {
    return ModalThematicsSelection.__super__.constructor.apply(this, arguments);
  }

  ModalThematicsSelection.prototype.submit = function(params) {
    var self = this,
        $thematicsSelection = this.$html.find('.library-items-selection'),
        $mainThematic = this.$html.find('.main-thematic'),
        selectedThematics = [];

    self.$html.find('.library-items-list-selected .library-item').each(function() {
      return selectedThematics.push([$(this).find('input').val(), $(this).find('.label-text').text()]);
    });

    if(selectedThematics.length == 1) {
      ModalThematicsSelection.__super__.submit.apply(this, arguments);
    } else if(selectedThematics.length == 0) {
      ModalThematicsSelection.__super__.close.apply(this, arguments);
    } else {
      var $thematicsSelect = $("<select data-plugin='limitless.selects.single'>" + (selectedThematics.map(function(selectedThematic) {
        return '<option value="' + selectedThematic[0] + '"' + (selectedThematic.length == 1 ? ' selected' : '') + '>' + selectedThematic[1] + '</option>';
      }).join('')) + "</select>");

      $mainThematic.children('.form-group').first().append($thematicsSelect);

      if ($thematicsSelection.is(':visible')) {
        appCustomerSpace.Loader().stop({$container: this.$html})
        $thematicsSelection.fadeOut(200, function() {
          self.$html.find('.modal-dialog').removeClass('modal-lg').addClass('modal-sm');
          $mainThematic.fadeIn();
          $thematicsSelect.on('change', 'select', function() {
            return $thematicsSelection.find('.library-item input[value=' + $(this).val() + ']').closest('.library-item').prependTo('.library-items-list-selected');
          });
          self.$html.find('.modal-closer').hide();
          appCustomerSpace.LimitlessPlugins.initPlugins($mainThematic);
        });
      } else {
        ModalThematicsSelection.__super__.submit.apply(this, arguments);
      }
    }
  };

  return ModalThematicsSelection;

})(appCustomerSpace.ModalLibraryItemsSelection);
